import React from 'react';
import { shape } from 'prop-types';
import { TtpContext } from '../../utils/ttp/index.js';

var propTypes = {
  /** Object that should contain TTP messages for current locale */
  value: shape({})
};
/* istanbul ignore next */
var defaultProps = {
  value: {}
};

/**
 * Provides React context for TTP messages to children via Context API.
 * @extends {Component<Props>}
 * @example
 * const translations = { foo: "bar" }
 * <TtpProvider value={translations}>
 *   <App />
 * </TtpProvider>
 */
var TtpProvider = function TtpProvider(props) {
  return /*#__PURE__*/React.createElement(TtpContext.Provider, props);
};
TtpProvider.propTypes = propTypes;
TtpProvider.defaultProps = defaultProps;

export { TtpProvider as default };
